import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedEmailTemplate } from "@idw-types/data/email-template";
import { useMemo } from "react";
import styles from "./email-template-content-preview.less";
import { EMAIL_TEMPLATE_SUBJECT_VARIABLE_NAME, emailTemplateContentStringRegex, REQUIRED_EMAIL_TEMPLATE_VARIABLES } from "@constants/email-template-constants";

type EmailTemplateContentPreviewProps = {
    state: FormattedEmailTemplate;
    selectedLanguage: LocaleTypes;
}

export const EmailTemplateContentPreview = ({ state, selectedLanguage }: EmailTemplateContentPreviewProps) => {

    const subject = useMemo(() => {
        return state.languages[selectedLanguage]?.[EMAIL_TEMPLATE_SUBJECT_VARIABLE_NAME] || "";
    }, [state.languages, selectedLanguage]);

    const contentWithoutVariables = useMemo(() => {
        const matches = state.template.match(emailTemplateContentStringRegex);

        let finalString = state.template;
        if (matches) {
            matches.forEach(match => {
                //@ts-ignore
                const splitVar = match.split(/!(.*)/s);
                if (splitVar && splitVar.length > 1) {
                    const variableName = splitVar[0].substring(3, splitVar[0].length - 1);
                    const variableValue = splitVar[1].substring(1, splitVar[1].length - 2);
                    let valueToDisplay = variableValue;

                    if (REQUIRED_EMAIL_TEMPLATE_VARIABLES.includes(variableName)) {
                        valueToDisplay = `{{${variableName}}}`;
                    } else {
                        const fieldNames = variableName.split(".");
                        let shouldUseLanguageFileValue = true;
                        if (state.languages[selectedLanguage] && fieldNames.length > 0) {
                            let finalObj = state.languages[selectedLanguage];
                            fieldNames.forEach(fieldName => {
                                if (finalObj[fieldName]) {
                                    finalObj = finalObj[fieldName];
                                } else {
                                    shouldUseLanguageFileValue = false;
                                }
                            });

                            if (shouldUseLanguageFileValue) {
                                //necessary to use any here because finalObj starts as { [key:string]: any } but becomes string
                                valueToDisplay = finalObj as any;
                            }
                        }
                    }

                    finalString = finalString.replace(match, `<acronym title="${variableName}">${valueToDisplay}</acronym>`);
                }
            });
        }

        // add id prefix to each of the css styles for preview
        if (finalString.includes("<style")) {
            const startIndex = finalString.indexOf("<style");
            const endIndex = finalString.indexOf("</style>");

            if (endIndex > -1) {
                const styleContentWithStartTag = finalString.substring(startIndex, endIndex);
                const endOfStyleTagIndex = styleContentWithStartTag.indexOf(">");

                if (endOfStyleTagIndex > -1) {
                    const styleContentWithoutTags = styleContentWithStartTag.substring(endOfStyleTagIndex + 1);
                    finalString =
                        finalString.substring(0, startIndex + endOfStyleTagIndex + 1) +
                        ` #email-template-content-preview { ${styleContentWithoutTags} } ` +
                        finalString.substring(endIndex);
                }
            }
        }

        return finalString;
    }, [state.template, state.languages, selectedLanguage]);

    return <div id="email-template-content-preview" className={styles.contentPreview}>
            <div className={styles.emailSubjectContainer}>
                    <label className={styles.subjectLabel}>
                        { /* @ts-ignore */}
                        <acronym title={subject}>{subject}</acronym>
                    </label>
                <label className={styles.fromLabel}>from: {state.sender}</label>
                <hr />
            </div>
        <div className={styles.emailContentContainer}>
            <div dangerouslySetInnerHTML={{ __html: contentWithoutVariables }} />
        </div>
    </div>
}